import { GenericError, IErrorDetails } from '@cian/peperrors/shared';

export class ResponseError extends GenericError {
  public constructor(configuration: { domain: string; message: string; details?: IErrorDetails }) {
    super({
      ...configuration,
      type: 'ResponseError',
    }) /* istanbul ignore next */;

    Object.setPrototypeOf(this, ResponseError.prototype);

    if (Error.captureStackTrace) {
      Error.captureStackTrace(this, ResponseError);
    } else {
      this.stack = new Error().stack;
    }
  }
}
